import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// styles
import styles from './PdpRespBreadcrumbs.scss';

// components
import { FormattedMessage } from 'react-intl';
import PdpRespBreadcrumb from './PdpRespBreadcrumb';

// helpers
import get from 'lodash.get';
import { trackBreadcrumbClick } from './breadcrumbTracking';

// messages
const homeLabel = <FormattedMessage id="PdpRespBreadcrumbs.homeLabel" defaultMessage="Home" />;

function PdpRespBreadcrumbs(props) {
    const breadcrumbs = get(props, 'item.breadcrumbs') || [];
    const addDivider = i => i < breadcrumbs.length - 1;

    // PdpRespBreadcrumbs Component
    return (
        <div className={styles.wrapper} data-tn="pdp-breadcrumbs-container">
            <ul>
                {/* Home Breadcrumb */}
                <PdpRespBreadcrumb
                    key="home"
                    addDivider
                    href="/"
                    onClick={() => trackBreadcrumbClick('home')}
                >
                    {homeLabel}
                </PdpRespBreadcrumb>
                {/* Category Breadcrumbs */}
                {breadcrumbs.map(({ key, displayName, path }, i) => (
                    <PdpRespBreadcrumb
                        key={path}
                        addDivider={addDivider(i)}
                        href={path}
                        onClick={() => trackBreadcrumbClick(key)}
                    >
                        {displayName}
                    </PdpRespBreadcrumb>
                ))}
            </ul>
        </div>
    );
}

PdpRespBreadcrumbs.propTypes = {
    item: PropTypes.object,
};

export default createFragmentContainer(PdpRespBreadcrumbs, {
    item: graphql`
        fragment PdpRespBreadcrumbs_item on Item {
            breadcrumbs {
                key
                path
                displayName
            }
        }
    `,
});
